import React, { Component } from 'react';
import Target_Cell from './Components/Target_Cell';
import { isEmpty } from '../Common/Common';
import { getEWManagementPoints, getTrendChartCategory } from '../Reports/util/util';
import './layout.css'

export default class Layout extends Component {
	constructor(props) {
		super(props);
		let layout_id = null;
		let layout_info = {};
		let base64ImageId = null;

		let resolution = { x: 1920, y: 1080 }
		let opacity = 1.0

		window.app.showLoading();

		if (!isEmpty(this.props.param.layouts)) {
			if (window.app.receiver.stored_params.hasOwnProperty('layout_id')) {
				if (!isEmpty(window.app.receiver.stored_params.layout_id)) {
					if (!isEmpty(this.props.param.layouts[window.app.receiver.stored_params.layout_id])) {
						layout_id = window.app.receiver.stored_params.layout_id;

						delete window.app.receiver.stored_params[layout_id];
					} else {
						layout_id = Object.keys(this.props.param.layouts)[0];
					}
				} else {
					layout_id = Object.keys(this.props.param.layouts)[0];
				}
			} else {
				layout_id = Object.keys(this.props.param.layouts)[0];
			}

			layout_info = this.props.param.layouts[layout_id];

			if (layout_info.hasOwnProperty('resolution')) resolution = layout_info.resolution;
			if (layout_info.hasOwnProperty('opacity')) opacity = layout_info.opacity;

			if (layout_info.bgImage != '' && layout_info.bgImage != null && layout_info.bgImage != 'null') {
				//retrieve from controller
				base64ImageId = layout_info.bgImage;

				this.props.receiver.loadImage({
					name: base64ImageId
				});
			}
		} else {
			window.app.hideLoading();
		}

		this.initPoints = { x1: 0, y1: 0, x2: 0, y2: 0 }
		this.endPoints = { x1: 0, y1: 0, x2: 0, y2: 0 }
		
		this.state = {
			layout_id: layout_id,
			layout_info: layout_info,
			base64ImageId: base64ImageId,
			base64Image: null,
			resolution: resolution,
			opacity: opacity,
			scaling: 1.0,
		}
	}

	/*
	 * for background image
	 */
	handleFileRead = async (event) => {
		const file = event.target.files[0];
		const base64 = await this.convertBase64(file);

		let tempLytInfo = this.state.layoutInfo;
		tempLytInfo.bgImage = file.name;

		this.setState({
			base64ImageId: file.name,
			base64Image: base64,
		});
	}

	convertBase64 = (file) => {
		return new Promise((resolve, reject) => {
			const fileReader = new FileReader();
			fileReader.readAsDataURL(file);

			fileReader.onload = () => {
				resolve(fileReader.result);
			}

			fileReader.onerror = (error) => {
				reject(error);
			}
		})
	}

	/*
	 * for setup
	 */
	handleChangePosition = (x, y, index) => {
		// Update the layout info when target cell position is changed
		let layout_info = this.state.layout_info;

		layout_info.target[index].x = x;
		layout_info.target[index].y = y;

		this.setState({ layout_info: layout_info });
	}

	/*
	 * for display
	 */

	handleChangeLayout = (layoutId) => {
		window.app.showLoading();
		let new_layout_info = JSON.parse(JSON.stringify(this.props.param.layouts[layoutId]));
		let base64ImageId = null;

		if (!isEmpty(new_layout_info)) {
			if (new_layout_info.bgImage != '' && new_layout_info.bgImage != null && new_layout_info.bgImage != 'null') {
				//retrieve from controller
				base64ImageId = new_layout_info.bgImage;

				this.props.receiver.loadImage({
					name: base64ImageId
				});

			} else {
				window.app.hideLoading();
			}

			this.setState({
				layout_info: {},
				base64ImageId: base64ImageId,
				base64Image: null
			}, () => {
				this.setState({
					layout_id: layoutId,
					layout_info: new_layout_info
				});
			});
		}
	}

	/*
	 * Reports functions
	 */

	handleReport = (report_type) => {
		let today = new Date();
		this.search_date = today; // Also the search_start_date
		this.search_end_date = today;
		this.search_points = [];
		let search_details = {};

		switch (report_type) {
			case 'trend':
				window.app.showLoading();
				this.props.receiver.getTrendPointList();
				break;
			case 'energy_management':
			case 'water_management':
				window.app.showLoading();
				this.report_type = report_type;
				//Alex 20210610 Changed to loadReportSettings
				//this.props.receiver.readJSONFile({name: 'report_settings.json'});
				this.props.receiver.loadReportSettings();
				break;
			case 'op_info':
				window.app.showLoading();
				let points = Object.keys(window.app.state.point_list);
				let end_date = new Date(this.search_date);
				end_date.setDate(end_date.getDate() + 1);

				// search_details = {"fy":year,"fm":month,"fd":day,"ty":year,"tm":month,"td":day,"points":[point id]}
				search_details = {
					fy: this.search_date.getFullYear(),
					fm: this.search_date.getMonth() + 1,
					fd: this.search_date.getDate(),
					ty: end_date.getFullYear(),
					tm: end_date.getMonth() + 1,
					td: end_date.getDate(),
					points: points
				}

				this.props.receiver.getDailyOpTime(search_details);
				break;
			case 'error_info':
				window.app.showLoading();
				search_details = {
					year: this.search_date.getFullYear(),
					month: this.search_date.getMonth() + 1,
					day: this.search_date.getDate(),
				}

				this.props.receiver.getDailyErrorInfo(search_details);
				break;
			default:
		}
	}

	handleSelectedCell = (cellId, cellType) => {

	}

	rcvTrendPointList = (response) => {
		// [[point id,type], …]
		let points = [];
		let count = 0;
		let selected_categories = [];
		this.trend_points = [];

		if (!isEmpty(response)) {
			this.trend_points = response;
			for (let row of response) {
				let point_id = row[0];
				// maximum for points at first
				if (count > 4) {
					break;
				}

				let point_info = window.app.state.point_list[point_id];
				let category = getTrendChartCategory(point_id);

				if (category != '') {
					if ((!selected_categories.includes(category) && selected_categories.length < 2) || (selected_categories.includes(category))) {
						points.push(row);
						selected_categories.push(category);
						count++;
					}
				}
			}
		}

		this.search_date.setHours(0, 0, 0);
		this.search_end_date = new Date(this.search_date);
		this.search_end_date.setDate(this.search_end_date.getDate() + 1);

		let search_details = {
			fy: this.search_date.getFullYear(),
			fm: this.search_date.getMonth() + 1,
			fd: this.search_date.getDate(),
			fh: 0,
			fmin: 0,
			ty: this.search_end_date.getFullYear(),
			tm: this.search_end_date.getMonth() + 1,
			td: this.search_end_date.getDate(),
			th: 0,
			tmin: 0,
			points: points
		}

		this.search_points = points;

		this.props.receiver.getTrend(search_details);
	}

	//Alex 20210610 Changed to loadReportSettings
	rcvLoadReportSettings = (report_settings) => {
		this.report_settings = report_settings;

		let points = getEWManagementPoints(this.report_settings.categories, this.report_type);
		let search_details = {
			year: this.search_date.getFullYear(),
			month: this.search_date.getMonth() + 1,
			day: this.search_date.getDate(),
			points: points,
		}

		this.props.receiver.getHourlyMeter(search_details);
	}

	rcvTrendData = (trend_data) => {
		window.app.hideLoading();
		window.app.content_area.current.switch_content.current.handleHideBottomMenu();
		this.props.content_handler('Trend_Data', { trend_data: trend_data, from: 'Layout', layout_id: this.state.layout_id, search_start_date: this.search_date, search_end_date: this.search_end_date, points: this.search_points, available_points: this.trend_points });
	}

	rcvHourlyMeter = (hourly_meter) => {
		window.app.hideLoading();
		window.app.content_area.current.switch_content.current.handleHideBottomMenu();
		this.props.content_handler('Energy_Water_Management', { report_type: this.report_type, meter_info: hourly_meter, categories: this.categories, from: 'Layout', layout_id: this.state.layout_id, search_date: this.search_date });
	}

	rcvDailyOpTime = (daily_op_time) => {
		window.app.hideLoading();
		window.app.content_area.current.switch_content.current.handleHideBottomMenu();
		this.props.content_handler('Operation_Info', { op_time: daily_op_time, from: 'Layout', layout_id: this.state.layout_id, search_date: this.search_date });
	}

	rcvDailyErrorInfo = (daily_err_info) => {
		window.app.hideLoading();
		window.app.content_area.current.switch_content.current.handleHideBottomMenu();
		this.props.content_handler('Error_Info_Report', { err_info: daily_err_info, from: 'Layout', layout_id: this.state.layout_id, search_date: this.search_date });
	}

	/*
	 * Reports functions
	 */

	rcvLoadImage(result) {
		if (result.hasOwnProperty('data')) {
			let imageString = result.data;

			this.setState({
				base64Image: imageString
			});
		} else {
			if (result.hasOwnProperty('result')) {
				if (result.result == 'NG') {
					window.app.showToast(this.props.receiver.getString('load_image_failed'), 3000);
				}
			}
		}
		window.app.hideLoading();
	}

	rcvExecuteScene = (response) => {
		if (response.result == 'OK') {
			window.app.showToast(this.props.receiver.getString('scene_success'), 3000);
		} else {
			window.app.showToast(this.props.receiver.getString('scene_fail'), 3000);
		}
	}

	render() {
		let main_content_style = {
			/*position: 'fixed',
			top: 0,
			width: '100%',
			height: this.props.height - 56,
			textAlign: 'right',	
			display: 'inline-block',
			//backgroundImage: `url(${this.state.base64Image})`,
			//backgroundRepeat: 'no-repeat',
			//backgroundAttachment: 'local',
			//overflow: 'auto',*/
			
			//New
			position: 	'absolute',
			width: 		'100%',
			height:		'calc(100% - 55px)',
			overflow:	'auto',
		}

		return (
			<div className='layoutMain'>
				<div id="maindisplay" style={main_content_style} className='slideInDown'>
					<div 
						id="layoutDisplay"
						className="layoutDisplay"
						style={{
							position: 'relative', 
							overflow: 'auto', 
							width: this.state.layout_id === null || !this.props.param.layouts[this.state.layout_id].hasOwnProperty('resolution') ? "1920px" : this.props.param.layouts[this.state.layout_id].resolution.x + "px", 
							height: this.state.layout_id === null || !this.props.param.layouts[this.state.layout_id].hasOwnProperty('resolution') ? "1080px" : this.props.param.layouts[this.state.layout_id].resolution.y + "px",
						}}
					>
						<img 
							style={{ 
								position: 'absolute', 
								opacity: this.state.layout_id === null ? 1.0 : this.props.param.layouts[this.state.layout_id].opacity,
								display: this.state.base64Image == null ? 'none' : 'block' 
							}} 
							src={this.state.base64Image} 
						/>
						{this.state.layout_info.target && this.state.layout_info.target.map((target_info, index) => {
							return (
								<Target_Cell
									key={index}
									index={index}
									width={this.props.width}
									groups={this.props.param.groups} // Need to retrieve groups and scenes 
									scenes={this.props.param.scenes} // before coming to Layout page
									layouts={this.props.param.layouts} // List of layouts
									layout_id={this.state.layout_id} //current layout id, for navigation
									layout_info={this.state.layout_info} // current layout detail
									target_info={target_info} // current target detail
									is_movable={false} // allow or disallow target cell to move
									handleChangePosition={this.handleChangePosition}
									handleChangeLayout={this.handleChangeLayout}
									handleReport={this.handleReport}
									handleSelectedCell={this.handleSelectedCell}
									receiver={this.props.receiver}
									content_handler={this.props.content_handler}
								/>
							)
						})}
					</div>
				</div>
			</div>
		)
	}
}